<script setup lang="ts">
import getAccountResponse from '@/types/responses/getAccount';
import Api from '@/services/api/ApiServiceFabrick';
import { onMounted, ref, computed } from 'vue';
import i18n from '@/lang/i18n';

const emit = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue: getAccountResponse | undefined;
  operationOfficeId: number | undefined;
  operationOfficeOnly: boolean | undefined;
}>()

const items = ref<getAccountResponse[]>([]);
const searchText = ref('');

onMounted(() => {
  Api().autoCompleteAccounts(undefined).then((data) => {
    items.value = data;
  });
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const normalize = (text: string) =>
  text.replace(/\s/g, '').replace(/\u3000/g, '').toLowerCase();

const filteredItems = computed(() => {
  let filteredItems = items.value

  if (props.operationOfficeOnly) {
    filteredItems = filteredItems.filter(item => {
      return item.operationOfficeId != null
    })
  }

  if (props.operationOfficeId) {
    resetModelValue()
    filteredItems = filteredItems.filter(item => {
      return item.operationOfficeId != null && item.operationOfficeId == props.operationOfficeId
    })
  }

  if (!searchText.value) {
    return filteredItems;
  }

  const query = normalize(searchText.value);
  return filteredItems.filter(item => normalize(item.name).includes(query));
});

function resetModelValue() {
  if (modelValue.value && modelValue.value?.operationOfficeId != props.operationOfficeId) {
    modelValue.value = undefined;
  }
}

</script>
<template>
  <v-combobox
    v-model="modelValue"
    v-model:search="searchText"
    :custom-filter="() => true"
    :label="i18n.global.t('pages.accounts.accountName')"
    item-title="name"
    item-value="id"
    :items="filteredItems"
    v-bind="{ 'return-object': true }"
  />
</template>
